import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { Box, Button, Paper, Stack } from "@mui/material";
import {
  DataGrid,
  GridToolbarDensitySelector,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import PlaylistAddRoundedIcon from "@mui/icons-material/PlaylistAddRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Grid } from "@mui/material";
import CustomInput from "../../../Components/CustomInput/CustomInput";
import CustomBackdrop from "../../../Components/CustomBackdrop/Barckdrop";
import axios from "axios";
import { genURL } from "../../../_getjson";
const styleMenu = {
  color: "black",
  cursor: "pointer",
  fontFamily: "Customfont !important",
  borderColor: "#bcbcbc",
  backgroundColor: "#bcbcbc",
};
export default function Payforservice(arg) {
  const { defaultrows, refdocnos } = arg;
  const [rows, setRows] = React.useState([]);
  const [value, setValue] = React.useState(0);
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [sumpricedefaultinputValue, setsumpricedefaultinputValue] =
    React.useState("0");
  const [sumwithholdingValue, setsumwithholdingValue] = React.useState("0");
  const [vatdefaultinputValue, setvatdefaultinputValue] = React.useState("0");
  const [openbackdrop, setopenbackdrop] = React.useState(false);

  // คอรั่มของตาราง
  const columns = [
    { field: "id", headerName: "ID", width: 40 },
    {
      field: "PRODUCTCODE",
      headerName: "รหัสสินค้า/บริการ",
      width: 250,
      editable: true,
      maxwidth: 250,
    },
    {
      field: "PRODUCTNAME",
      headerName: "ชื่อสินค้า/บริการ",
      width: 250,
      editable: true,
      maxwidth: 250,
      editable: false,
      sortable: false,
    },
    {
      field: "AMOUNT",
      headerName: "จำนวนเงิน",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: true,
    },

    {
      field: "PAYBALANCE",
      headerName: "คงค้าง",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "WTAXRATE",
      headerName: "อัตรา",
      width: 100,
      editable: false,
      sortable: false,
    },
    {
      field: "PAYAMOUNT",
      headerName: "ยอดชำระ",
      width: 100,
      editable: true,
      sortable: false,
    },
    {
      field: "WTAXAMOUNT",
      headerName: "ภาษี ณ ที่จ่าย",
      width: 100,
      editable: false,

      sortable: false,
    },
    {
      field: "INCOMETYPE",
      headerName: "INCOMETYPE",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: true,
    },
    {
      field: "ITEMTAXTYPE",
      headerName: "ITEMTAXTYPE",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: true,
    },
    {
      field: "REFDOCNO",
      headerName: "REFDOCNO",
      width: 200,
      editable: false,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: false,
    },
    {
      field: "REFDOCTYPE",
      headerName: "REFDOCTYPE",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: true,
    },
    {
      field: "REFLINEID",
      headerName: "REFLINEID",
      width: 200,
      editable: true,
      maxwidth: 200,
      editable: false,
      sortable: false,
      hide: true,
    },
  ];

  React.useEffect(() => {
    console.log("useEffectsumtax");
    sumtax();
    //setRows(newState)
    if (rows.length <= 0) {
      setRowsEmty();
    }
    return () => {};
  }, [rows]);

  React.useEffect(async () => {
    console.log("useEffectdefaultrows", defaultrows);
    await setRows(defaultrows);
    return () => {};
  }, [defaultrows]);

  React.useEffect(async () => {
    console.log("useEffectdefaultrows", defaultrows);

    return () => {
      arg.reswithholding(sumwithholding);
      arg.resrowsData(rows);
    };
  }, []);

  const sumtax = async () => {
    let sumtax = 0;
    let sumpayamount = 0;
    let sumwithholding = 0;
    rows.forEach((element) => {
      sumpayamount = sumpayamount + Number(element.PAYAMOUNT);
      sumwithholding = sumwithholding + Number(element.WTAXAMOUNT);
    });

    sumtax = await (sumpayamount * (7 / 100));

    await setsumpricedefaultinputValue(sumpayamount.toFixed(2));
    await setvatdefaultinputValue(sumtax.toFixed(2));
  };
  const setRowsEmty = () => {
    if (rows.length <= 0) {
      let field = [];
      columns.forEach((element) => {
        if (element.field != "id") {
          field.push(element.field);
        }
      });
      console.log("field", field);
      for (let index = 0; index < 15; index++) {
        setRows((prevRows) => [...prevRows, createRow(field, true)]);
      }
    }
  };
  let idCounter = 0;
  const createRow = (data, empty) => {
    // ถ้ามีข้อมูลใน rows staet
    if (rows.length > 0) {
      const ids = rows.map((object) => {
        return object.id;
      });
      const max = Math.max(...ids);
      idCounter = max;
    }
    idCounter += 1;
    let lastdata;
    if (empty === true) {
      let newdata = data.reduce(
        (a, v) => ({
          ...a,
          [v]:
            v.search(/date/) > -1
              ? new Date()
              : v.search(/arcode/) > -1
              ? userData[0]
              : v.search(/arname/) > -1
              ? userData[1]
              : "",
        }),
        {}
      );
      lastdata = { ...newdata, id: idCounter };
    }
    // console.log(lastdata);
    return lastdata;
  };
  //------ option report -------------------------

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={<PlaylistAddRoundedIcon />}
            size="small"
            onClick={handleAddRow}
            sx={styleMenu}
          >
            เพิ่มแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<DeleteOutlineRoundedIcon />}
            onClick={(e) => delData()}
            size="small"
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ลบแถว
          </Button>
          <Button
            variant="outlined"
            startIcon={<CheckCircleOutlineRoundedIcon />}
            size="small"
            // onClick={e => selectData()}
            style={{ display: selectionModel.length > 0 ? "inherit" : "none" }}
            sx={styleMenu}
          >
            ตกลง
          </Button>
          <GridToolbarDensitySelector sx={styleMenu} />
        </Stack>
      </GridToolbarContainer>
    );
  };
  const delData = async () => {
    const selectedIDs = new Set(selectionModel);
    // you can call an API to delete the selected IDs
    // and get the latest results after the deletion
    // then call setRows() to update the data locally here
    await setRows((r) => r.filter((x) => !selectedIDs.has(x.id)));
  };
  // เพิ่มแถวในตาราง
  const handleAddRow = () => {
    let field = [];
    columns.forEach((element) => {
      if (element.field != "id") {
        field.push(element.field);
      }
    });
    setRows((prevRows) => [...prevRows, createRow(field, true)]);
    // setTimeout(() => {
    //     console.log("handleAddRow", rows)
    // }, 300);
  };
  const processRowUpdate = async (newRow) => {
    // setopenbackdrop(true)
    console.log("DataGrid processRowUpdate", newRow);
    let newRowData = [];
    for (let index = 0; index < rows.length; index++) {
      if (newRow.id === rows[index].id) {
        if (Number(newRow.PAYAMOUNT) > 0 && Number(newRow.WTAXRATE) > 0) {
          let x = Number(newRow.PAYAMOUNT) * (Number(newRow.WTAXRATE) / 100);
          console.log("DataGrid processRowUpdate", x);
          newRowData.push({
            id: newRow.id,
            PRODUCTCODE: newRow.PRODUCTCODE,
            PRODUCTNAME: newRow.PRODUCTNAME,
            AMOUNT: newRow.AMOUNT,
            PAYBALANCE: newRow.PAYBALANCE,
            WTAXRATE: newRow.WTAXRATE,
            INCOMETYPE: newRow.INCOMETYPE,
            ITEMTAXTYPE: newRow.ITEMTAXTYPE,
            REFDOCNO: newRow.REFDOCNO,
            REFDOCTYPE: newRow.REFDOCTYPE,
            REFLINEID: newRow.REFLINEID,
            PAYAMOUNT: newRow.PAYAMOUNT,
            WTAXAMOUNT: x.toFixed(2),
            INCOMETYPENAME: newRow.INCOMETYPENAME,
          });
          // setDefaultinputValue(Number(defaultinputValue) + x);
        } else {
          newRowData.push(newRow);
        }
      } else {
        newRowData.push(rows[index]);
      }
    }
    console.log("DataGrid processRowUpdate newRowData", newRowData);
    await setRows(newRowData);
    // await setopenbackdrop(false)
    return newRow;
  };
  const cleanData = async () => {
    await setRows([]);
  };
  const loadcsvarpaywtax = async (e) => {
    console.log("refdocnos", refdocnos);
    setopenbackdrop(true);
    let url = "";
    if (e === "nonzero") {
      url = `csvarpaywtax/csvarpaywtax?zeropaybalance=false&top=32767`;
    } else {
      url = `csvarpaywtax/csvarpaywtax?zeropaybalance=true`;
    }
    ///----------------test local--------------------------
    // if (e === "nonzero") {
    //     url = `csvarpaywtax?zeropaybalance=false&top=32767`
    // } else {
    //     url = `csvarpaywtax?zeropaybalance=true`
    // }
    url += `&refdocno=` + refdocnos;
    let rs = await axios.get(genURL(url));
    let element = [];
    await console.log("elementzzzzzzzzzzz rs.data.length", genURL(url));
    if (rs.data.length > 0) {
      console.log("loadcsvarpaywtax", rs.data);

      for (let index = 0; index < rs.data.length; index++) {
        console.log(rs.data[index]);
        element.push({
          id: Number(index) + 1,
          PRODUCTCODE: rs.data[index].PRODUCTCODE,
          PRODUCTNAME: rs.data[index].PRODUCTNAME,
          AMOUNT: rs.data[index].AMOUNT,
          PAYBALANCE: rs.data[index].PAYBALANCE,
          WTAXRATE: rs.data[index].WTAXRATE,
          PAYAMOUNT: rs.data[index].PAYBALANCE,
          INCOMETYPE: rs.data[index].INCOMETYPE,
          ITEMTAXTYPE: rs.data[index].ITEMTAXTYPE,
          REFDOCNO: rs.data[index].REFDOCNO,
          REFDOCTYPE: rs.data[index].REFDOCTYPE,
          REFLINEID: rs.data[index].REFLINEID,
          WTAXAMOUNT: (
            Number(rs.data[index].PAYBALANCE) *
            (Number(rs.data[index].WTAXRATE) / 100)
          ).toFixed(2),
          INCOMETYPENAME: rs.data[index].INCOMETYPENAME,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      // console.log("rs elementzzzzzzzzzzz", element);
      // await setusedata(element)
    }
    await setRows(element);
    await setopenbackdrop(false);
  };
  const calTax = async () => {
    await setopenbackdrop(true);
    let sumtax = 0;
    let sumpayamount = 0;
    let sumwithholding = 0;
    rows.forEach((element) => {
      sumpayamount = sumpayamount + Number(element.PAYAMOUNT);
      sumwithholding = sumwithholding + Number(element.WTAXAMOUNT);
    });

    sumtax = await (sumpayamount * (7 / 100));
    await setsumpricedefaultinputValue(sumpayamount.toFixed(2));
    await setvatdefaultinputValue(sumtax.toFixed(2));
    await setsumwithholdingValue(sumwithholding);
    await setopenbackdrop(false);
    await arg.reswithholding(sumwithholding);
    await arg.resrowsData(rows);
  };

  return (
    <>
      <Box sx={{ width: "100%", height: 500 }}>
        <DataGrid
          rows={rows}
          columns={columns}
          editMode="row"
          rowHeight={38}
          processRowUpdate={processRowUpdate}
          checkboxSelection
          disableSelectionOnClick
          onSelectionModelChange={(newSelectionModel) => {
            setSelectionModel(newSelectionModel);
          }}
          selectionModel={selectionModel}
          onRowEditCommit={console.log("DataGrid onRowEditCommit")}
          experimentalFeatures={{ newEditingApi: true }}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Typography>
            {" "}
            1.กดเคลียร์รายการเดิม{" "}
            <Button onClick={(e) => cleanData()}>เคลียร์รายการเดิม</Button>
          </Typography>
          <Typography>
            {" "}
            2.กดแสดงสินค้า/บริการตามรายการ Invoive{" "}
            <Button onClick={(e) => loadcsvarpaywtax("nonzero")}>
              แสดงสินค้า/บริการ
            </Button>{" "}
            <Button onClick={(e) => loadcsvarpaywtax()}>
              แสดงสินค้า/บริการยอดเต็มบิล
            </Button>{" "}
          </Typography>
          <Typography>
            {" "}
            3.ทุกครั้งที่แก้ไขยอดชำระให้กดปุ่ม{" "}
            <Button onClick={(e) => calTax()}>
              คำนวณภาษี ณ ที่จ่ายและภาษีมูลค่าเพิ่ม{" "}
            </Button>
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <CustomInput
            label={"รวมยอดชำระ"}
            id="sumprice"
            onBlur={(e) => console.log(e)}
            inputType={"number"}
            defaultValue={sumpricedefaultinputValue.toString()}
          />
          <CustomInput
            label={"ภาษีมูลค่าเพิ่ม"}
            id="vat"
            onBlur={(e) => console.log(e)}
            inputType={"number"}
            defaultValue={vatdefaultinputValue.toString()}
          />
        </Grid>
      </Grid>

      <CustomBackdrop open={openbackdrop} />
    </>
  );
}
Payforservice.propTypes = {
  defaultrows: PropTypes.string,
  refdocnos: PropTypes.array,
};
